import { helpers, React, ts, ui, useSelector } from '_core';

import { Params } from './types';
import { prepareBucketedNames } from '../../common/utils/get-series-name';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  returns: string;
  fullScreen: boolean;
  params: Params;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, returns, fullScreen, params, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);
  const resources = useSelector((state) => state.resources);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: returns,
        },
      });
      if (response) setData(prepareBucketedNames(response.data, params.buckets.type, params.buckets.value, resources));
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (returns && params.scale) loadData();
    return () => setData(null);
  }, [returns, params.scale]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      numberFormat="#.##%"
    />
  );
};

export default Chart;
